// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;The Lord will record as he writes up the peoples,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;&#145;This one also was born there.&#146;<br> </p> </div></div>";
// Exports
module.exports = code;